export default __webpack_public_path__ + "static/media/DocGif.684994f5.gif";